import { styled } from '@mui/material/styles';

const HR = styled('hr')(({ theme }) => {

    const isDark = theme.palette.mode === 'dark';

    return {
        lineHeight: '1em',
        position: 'relative',
        border: 0,
        textAlign: 'center',
        height: '1.5em',
        margin: '12px 0',
        opacity: 0.7,

        /* Linie */
        '&:before': {
            content: '""',
            background: `linear-gradient(to right, transparent, ${
                isDark ? 'rgba(255,255,255,.4)' : '#818078'
            }, transparent)`,
            position: 'absolute',
            left: 0,
            top: '50%',
            width: '100%',
            height: '1px',
        },

        /* Text */
        '&:after': {
            content: 'attr(data-content)',
            position: 'relative',
            display: 'inline-block',
            padding: '0 .5em',
            lineHeight: '1.5em',
            color: isDark ? theme.palette.grey[300] : '#818078',
            backgroundColor: isDark ? '#373341' :theme.palette.background.paper,
        },
    };
});

export default HR;
